<!-- Header -->
<div class="page-heading-blue">
  <div class="pt-4 pl-4">
    <span>{{ 'CHANNEL' | translate }} <i class="fal fa-angle-right"></i></span>
  </div>
  <div class="row p-4">
    <div class="col-4">
      <h2>{{ channel.name }}</h2>
      <br>
      <span>{{'PROGRAM-LEAD' | translate}}: {{channel.leader}}</span>
    </div>
    <div class="col-6">
      {{ channel.description }}
    </div>
    <div class="col-2">
      <div class="mt-2 text-right">
        <button class="btn btn-outline-light" (click)="downloadReport()">
          {{ 'DOWNLOAD-REPORT' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Body -->
<div class="content-background">

  <h5 class="pt-2 pb-2" *ngIf="!staffUserSelected">
    <span class="montserrat font-weight-bold text-uppercase">{{'CHANNEL-OVERVIEW' | translate}}</span>
  </h5>
  <h5 class="pt-2 pb-2" *ngIf="staffUserSelected">
    <span class="montserrat font-weight-bold text-uppercase attention">{{staffUserSelected.name}}</span>
  </h5>

  <div class="row">

    <!-- Tasks stat -->
    <div class="col-xl-4 col-md-6 col-xs-12 pl-2 pb-2">
      <div class="card m-2 h-100 text-center">
        <div class="card-body d-flex justify-content-center">
          <div *ngIf="loading" class="row">
            <div class="col my-auto">
              <span class="k-icon k-i-loading kendo-loading-icon"></span>
            </div>
          </div>
          <div *ngIf="!loading" class="row w-100 align-self-center">
            <div class="col-4 my-auto k-text-primary">
              <span class="dash-numeric" *ngIf="!loadingCounts"
                title="{{(staffUserSelected ? staffUserSelected.open : taskStat.open)}}">{{(staffUserSelected ?
                staffUserSelected.open : taskStat.open) | roundNumber}}</span>
              <br>
              <span class="dash-label">{{ 'OPEN' | translate | uppercase }}</span>
            </div>
            <div class="col-4 my-auto m-0 p-0">
              <!-- Tasks pie chart -->
              <kendo-chart [transitions]="true" style="height: 180px;">
                <kendo-chart-area opacity="0"></kendo-chart-area>
                <kendo-chart-tooltip>
                  <ng-template kendoChartSeriesTooltipTemplate let-item="dataItem">
                    {{item.category}} {{percentageInt(item.percentage)}}%
                  </ng-template>
                </kendo-chart-tooltip>
                <kendo-chart-series>
                  <kendo-chart-legend [visible]="false"></kendo-chart-legend>
                  <kendo-chart-series-item type="pie"
                    [data]="staffUserSelected ? staffUserSelected.taskPieData : taskPieData" field="value"
                    categoryField="category" colorField="color" [border]="{ width: 1.5, color: '#909ea8' }">
                  </kendo-chart-series-item>
                </kendo-chart-series>
              </kendo-chart>
              <!-- end of chart -->
            </div>
            <div class="col-4 my-auto k-text-error">
              <span class="dash-numeric" *ngIf="!loadingCounts"
                title="{{staffUserSelected ? staffUserSelected.late : taskStat.late}}">{{staffUserSelected ?
                staffUserSelected.late : taskStat.late | roundNumber}}</span>
              <br>
              <span class="dash-label">{{ 'LATE' | translate | uppercase }}</span>
            </div>
          </div>
        </div>
        <div class="card-footer">
          <h4 class="montserrat">{{ 'TASKS' | translate | uppercase }}</h4>
        </div>
      </div>
    </div>

    <!-- Goals stat -->
    <div class="col-xl-4 col-md-6 col-xs-12 pl-2 pb-2">
      <div class="card m-2 h-100 text-center" *ngIf="!staffUserSelected">
        <div class="card-body d-flex justify-content-center">
          <div *ngIf="goalLoading" class="row">
            <div class="col my-auto">
              <span class="k-icon k-i-loading kendo-loading-icon"></span>
            </div>
          </div>
          <div *ngIf="!goalLoading" class="align-self-center">
            <div class="row mb-2" *ngIf="channel.statistics; let stat">
              <div class="col">
                <span class="dash-label text-uppercase" *ngIf="stat.targetDaysToCloseCase > 0">
                  {{'TARGET-DAYS-TO-CLOSE' | translate}}: {{stat.targetDaysToCloseCase}}
                </span>
              </div>
            </div>
            <div class="row w-100">
              <div class="col my-auto" *ngIf="channel && channel.goalPercentageInteger >= 0">
                <!-- Goal SLA donut chart -->
                <kendo-chart [transitions]="true" style="height: 180px;">
                  <kendo-chart-area opacity="0"></kendo-chart-area>
                  <ng-template kendoChartDonutCenterTemplate>
                    <span class="dash-numeric">{{channel.goalPercentageInteger}}%
                    </span>
                  </ng-template>
                  <kendo-chart-series>
                    <kendo-chart-series-item type="donut" [data]="goalData" [margin]="0" [padding]="0"
                      [startAngle]="180" [holeSize]="65" categoryField="category" field="value" colorField="color">
                      <kendo-chart-series-item-tooltip color="white" background="#557288">
                        <ng-template let-caption="category">
                          {{caption}}
                        </ng-template>
                      </kendo-chart-series-item-tooltip>
                    </kendo-chart-series-item>
                  </kendo-chart-series>
                  <kendo-chart-legend [visible]="false"></kendo-chart-legend>
                </kendo-chart>
                <!-- end of chart -->
              </div>
              <div [ngClass]="['col', 'my-auto', channel.statusClass]" *ngIf="channel.statistics; let stat">
                <span class="dash-numeric">
                  {{stat.averageDaysToCloseCase}}
                </span>
                <br>
                <span class="dash-label text-uppercase">{{ 'AVERAGE-DAYS-TO-CLOSE' | translate }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="card-footer">
          <h4 class="montserrat text-uppercase">{{'GOALS' | translate}}</h4>
        </div>
      </div>
    </div>

    <!-- Cases stat -->
    <div class="col-xl-4 col-md-6 col-xs-12 pl-2 pb-2">
      <div class="card m-2 h-100 text-center" *ngIf="!staffUserSelected">
        <div class="card-body">
          <div *ngIf="historyLoading" class="row">
            <div class="col my-auto">
              <span class="k-icon k-i-loading kendo-loading-icon"></span>
            </div>
          </div>
          <div *ngIf="!historyLoading" class="row">
            <div class="col my-auto">
              <!-- Case open/close history line chart -->
              <kendo-chart [transitions]="true" style="height: 150px;">
                <kendo-chart-messages noData="{{'GRID-NO-DATA' | translate}}"> </kendo-chart-messages>
                <kendo-chart-area opacity="0"></kendo-chart-area>
                <kendo-chart-legend position="bottom" orientation="horizontal">
                </kendo-chart-legend>
                <kendo-chart-category-axis>
                  <kendo-chart-category-axis-item [categories]="historyData.weekdaySeries" [labels]="{padding: 2}">
                  </kendo-chart-category-axis-item>
                </kendo-chart-category-axis>
                <kendo-chart-value-axis>
                  <kendo-chart-value-axis-item [min]="-2" [max]="historyData.yMax" [majorUnit]="1"
                    [labels]="{skip: 2, step: historyData.yStep}">
                  </kendo-chart-value-axis-item>
                </kendo-chart-value-axis>
                <kendo-chart-series>
                  <kendo-chart-series-item type="line" [data]="historyData.caseOpenedSeries"
                    name="{{ 'OPENED' | translate}}">
                    <kendo-chart-series-item-tooltip format="{{ 'OPENED' | translate}} {0}">
                    </kendo-chart-series-item-tooltip>
                  </kendo-chart-series-item>
                  <kendo-chart-series-item type="line" [data]="historyData.caseClosedSeries"
                    name="{{ 'CLOSED' | translate}}">
                    <kendo-chart-series-item-tooltip format="{{ 'CLOSED' | translate}} {0}">
                    </kendo-chart-series-item-tooltip>
                  </kendo-chart-series-item>
                </kendo-chart-series>
              </kendo-chart>
              <!-- end of chart -->
            </div>
          </div>
          <div class="row" *ngIf="channel.statistics; let stat">
            <div class="col my-auto k-text-primary">
              <span class="dash-numeric" title="{{stat.openCases}}">{{stat.openCases | roundNumber}}</span>
              <br>
              <span class="dash-label">{{'OPEN' | translate | uppercase}}</span>
            </div>
            <div [ngClass]="['col', 'my-auto', channel.statusClass]">
              <span class="dash-numeric">
                {{historyData.closureRate}}
              </span>
              <span class="dash-label text-muted"> / {{'WEEK' | translate | uppercase}}</span>
              <br>
              <span class="dash-label">{{'CLOSURE-RATE' | translate | uppercase}}</span>
            </div>
          </div>
        </div>
        <div class="card-footer">
          <h4 class="montserrat">{{'CASES' | translate | uppercase}}</h4>
        </div>
      </div>
    </div>
  </div>

  <br><br>

  <div class="row">
    <!-- Staff list -->
    <div class="col-3">
      <h5 class="montserrat font-weight-bold text-uppercase">{{'STAFF' | translate}} & {{'OPEN-TASKS' | translate}}</h5>
      <br>
      <div *ngIf="loading" class="text-center">
        <span class="k-icon k-i-loading kendo-loading-icon"></span>
      </div>
      <!-- clicking outside this div deselects the selected staff member -->
      <div *ngIf="!loading" (clickOutside)="clickOutside()" [exclude]="'a,button,#taskAssigneeDialog'"
        [excludeBeforeClick]="true">
        <div [ngClass]="['card', 'mb-1', 'staff-card', staff.get(userName).selected ? 'card-selected' : 'border']"
          *ngFor="let userName of staffUserNames">
          <div *ngIf="staff.get(userName); let user" (click)="filterTasksByUser(user)" class="card-body pl-2">
            <div class="row card-text text-center no-gutters">
              <div class="col-md-5 col-lg-5 col-xl-4 my-auto">
                <img *ngIf="userName !== 'Unassigned' && photoMap.has(userName) && photoMap.get(userName).length > 2"
                  [src]="photoMap.get(userName)" alt="{{'PHOTO' | translate}}" class="avatar-custom">
                <kendo-avatar
                  *ngIf="userName !== 'Unassigned' && photoMap.has(userName) && photoMap.get(userName).length <= 2"
                  class="avatar-custom" shape="circle" initials="{{photoMap.get(userName)|uppercase}}">
                </kendo-avatar>
              </div>
              <div class="col-md-7 col-lg-7 col-xl-8">
                <h5>{{user.name}}</h5>
                <div class="row m-auto"
                  [ngClass]="{'pl-3 pr-3': (user.late > 0 && user.onTime > 0) || (user.late === 0 && user.onTime > 0) || (user.late > 0 && user.onTime === 0)}">
                  <kendo-chart style="display: inline; max-height: 40px;">
                    <kendo-chart-area opacity="0"></kendo-chart-area>
                    <kendo-chart-axis-defaults [visible]="false" [majorGridLines]="{visible: false}">
                    </kendo-chart-axis-defaults>
                    <kendo-chart-series>
                      <kendo-chart-series-item type="bar" [stack]="{ type: '100%' }"
                        [data]="[{value: (user.open-user.late)*-1, color: '#53a5a1'}]" field="value" colorField="color">
                      </kendo-chart-series-item>
                      <kendo-chart-series-item type="bar" [data]="[{value: user.late, color: '#cf4526'}]" field="value"
                        colorField="color">
                      </kendo-chart-series-item>
                    </kendo-chart-series>
                  </kendo-chart>
                </div>
                <div class="row">
                  <div class="col green pr-0" title="{{user.open}}"><i class="fas fa-folder-open"></i>
                    {{'OPEN' | translate}}:
                    {{user.open | roundNumber}}
                  </div>
                  <div class="col bad">
                    <i class="fas fa-exclamation-triangle" title="{{user.late}}"></i> {{'LATE' | translate}}:
                    {{user.late | roundNumber}}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Task list -->
    <div class="col-9">
      <h5 class="montserrat font-weight-bold text-uppercase">{{'OUTSTANDING-TASKS' | translate}}
        <span class="montserrat attention text-uppercase" *ngIf="staffUserSelected">: {{staffUserSelected.name}}</span>
      </h5>
      <br>
      <kendo-grid [data]="gridView" [loading]="loading" [navigable]="true"
        [pageable]="taskCount > state.take ? { buttonCount: 5, pageSizes: pageSizes} : false" [pageSize]="state.take"
        [skip]="state.skip" [sortable]="true" [sort]="state.sort" [resizable]="true"
        (dataStateChange)="dataStateChange($event)">
        <kendo-grid-messages noRecords="{{ 'NO-TASKS' | translate }}">
        </kendo-grid-messages>
        <kendo-grid-column field="caseName" title="{{ 'CASE' | translate }}" [width]="80" class="emphasizedLabel">
          <ng-template kendoGridCellTemplate let-dataItem>
            <a [routerLink]="['/case', dataItem.caseId]" class="pointer font-weight-bold">
              {{dataItem.caseName}}
            </a>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="name" title="{{ 'TASK' | translate }}" [width]="120"></kendo-grid-column>
        <kendo-grid-column field="assignee" title="{{ 'ASSIGNEE' | translate }}" [width]="80">
          <ng-template kendoGridCellTemplate let-dataItem>
            {{dataItem.assigneeName}}
            <a class="pointer float-right" title="{{'REASSIGN' | translate}}"
              (click)="openTaskAssigneeDialog(dataItem)">
              <i class="fas fa-undo icon-info"></i>
            </a>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="openedOn" title="{{ 'OPENED-ON' | translate }}" [width]="70" filter="date"
          format="{0:d}"></kendo-grid-column>
        <kendo-grid-column field="dueDate" title="{{ 'DUE-ON' | translate }}" [width]="70" filter="date" format="{0:d}">
          <ng-template kendoGridCellTemplate let-dataItem>
            <span *ngIf="dataItem.dueDate!==null">{{ intl.formatDate(intl.parseDate(dataItem.dueDate), "d") }}</span>
            <a class="pointer float-right" title="{{'EDIT' | translate}}" (click)="openTaskDuedateDialog(dataItem)">
              <i class="fas fa-undo icon-info"></i>
            </a>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="daysLeft" title="{{ 'STATUS' | translate }}" [width]="40" class="text-center">
          <ng-template kendoGridCellTemplate let-dataItem>
            <i *ngIf="dataItem.dueDate" [ngClass]="[dataItem.statusIcon]"
              title="{{ dataItem.statusTitle | translate }}"></i>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="priority" title="{{ 'PRIORITY' | translate }}" [width]="40" class="text-center">
          <ng-template kendoGridCellTemplate let-dataItem>
            <div [ngClass]="[dataItem.priorityBadgeClass]">{{dataItem.priority.charAt(0)}}</div>
          </ng-template>
        </kendo-grid-column>
      </kendo-grid>
    </div>
  </div>
</div>

<!-- task assignment dialog -->
<app-task-assign [task]="task" [dialogOpened]="assigneeDialogOpened" (closing)="closeTaskAssigneeDialog();"
  (save)="updateTaskAssignee($event)">
</app-task-assign>

<!-- duedate task dialog -->
<app-task-duedate [task]="task" [dialogOpened]="taskDueDateOpened" (closing)="closeTaskDueDateDialog()"
  (save)="updateTaskDueDate($event)">
</app-task-duedate>

<kendo-dialog *ngIf="reportDialogOpened" title="{{'CHANNEL-REPORT' | translate}}" (close)="closeDocumentViewerDialog()"
  [width]="1024">
  <!--loading-->
  <div *ngIf="loadingDocument" class="m-5">
    <div class="container">
      <div class="row justify-content-center">
        <span class="k-icon k-i-loading kendo-loading-icon"></span>
      </div>
    </div>
  </div>
  <!--Show document based on type-->
  <div *ngIf="!loadingDocument" class="document-content">
    <kendo-pdfviewer style="width:100%;height:100vh;" [data]="documentContent" [tools]="pdfViewerTools" [zoom]="0.75">
    </kendo-pdfviewer>
  </div>
  <kendo-dialog-actions>
    <button kendoButton (click)="closeDocumentViewerDialog()">{{ 'CLOSE' | translate }}</button>
  </kendo-dialog-actions>
</kendo-dialog>